import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { MoveStagedAliquotResult } from '../../core/api/lab.types';

export const moveStagedAliquoteHasErrorSelector = (state: RootState): any =>
  state.moveStagedAliquot.errors && state.moveStagedAliquot.errors
    ? { hasError: true, message: state.moveStagedAliquot.errors[0].message }
    : { hasError: false };

export const moveStagedAliquoteIsBusySelector = (state: RootState): boolean =>
  state.moveStagedAliquot.status === StoreStatus.BUSY;

export const moveStagedAliquoteResponseSelector = (state: RootState): MoveStagedAliquotResult | null =>
  state.moveStagedAliquot.response || null;
